import { Component, OnInit, ElementRef, Input, Output, EventEmitter, SimpleChanges, Renderer2, ViewChild, ApplicationRef, ComponentFactoryResolver, Injector, ChangeDetectorRef } from '@angular/core';
import * as WebUploader1 from 'webuploader'
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwViewFileService } from 'src/app/librarys/serves/public/sw-view-file.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageConfirmComponent } from '../../sw-massage-confirm/sw-massage-confirm.component';
import { SwModalframeComponent } from '../../sw-modal-frame/sw-modal-frame.component';
import Cropper from 'cropperjs'
import { GetSuffixImgService } from 'src/app/librarys/serves/public/get-suffix-img.service';
declare var $: any;

@Component({
  selector: 'app-sw-file-upload-new-modal',
  templateUrl: './sw-file-upload-new-modal.component.html',
  styleUrls: ['./sw-file-upload-new-modal.component.css']
})
export class SwFileUploadNewModalComponent implements OnInit {

  /**
 * 是否只允许上传单个文件，再次上传则覆盖
 */
  @Input() onlyOneFile: boolean = false
  /**
   * 动态创建上传组件的模态框的传入的参数
   */
  @Input() param: any;

  /**
   * 动态创建上传组件的模态框的回调
   */
  @Output() callback = new EventEmitter();

  /**
   * 上传前配置项的查询,根据父组件传递过来的值进行查询,functionId  或者是 code 任一种
   */
  @Input() fileFunctionId: string = ""

  /**
   * 上传前配置项的查询,根据父组件传递过来的值进行查询,functionId  或者是 code 任一种
   */
  @Input() fileCode: string = ""

  /**
   * 业务id
   */
  @Input() fileBusinessId: string = ""

  /**
   * 根据策略查询到的上传配置
   */
  @Input() uploadObj: any

  /**
   * 根据策略查询到的上传配置
   */
  @Input() fileOrImg: any

  /**
   * 预览图片时添加的水印文字
   */
  @Input() watermark: string = ""

  /**
   * 实例化 WebUploader时的id,如果一个页面上只需要一个文件上传组件,不需要传递此值
   */
  @Input() label3: string = "";

  /**
   * 没有业务id时,传入文件信息id进行回填
   */
  @Input() fileInfoIds: any[] = []

  /**
   * 展示在模态框上的文件列表
   */
  @Input() showList2: any[] = []

  /**
   * 不展示上传文件按钮以及文件展示,直接调用 selectFiles 方法,弹出模态框
   */
  @Input() justModal: boolean = false

  /**
  * 组件是否是只读属性
  */
  @Input() fileIsReadOnly: boolean = false

  /**
   * @ignore
   * 上传成功的文件和删除的文件信息
   */
  @Input() list: any
  /*  = {   
    'addList':[],
    'delList':[]
  } */

  /**
   * @ignore
   * 确认弹窗组件
   */
  @ViewChild("tirm") tirm!: SwMassageConfirmComponent;
  @ViewChild("fileUploadModal") fileUploadModal!: SwModalframeComponent;

  /**
   * @ignore
   * 当文件添加到队列中之后,获取图片对象数组
   */
  fileList: any[] = []

  /**
   * @ignore
   * webUploader 文件上传初始化的 uploader
   */
  fileUploader: any

  /**
   * @ignore
   * 上传路径--输入属性，如果业务端不传此参数，那么就将空值传入上传接口，后台会判断是否有值，没有的话，后台会从策略中读取
   */
  @Input() uploadPath: string = ''

  /**
   * 新的文件名
   */
  @Input() newFileName: string = ""

  /**
   * @ignore
   * 存放已经上传的文件的信息
   */
  uploadedFilesInfo: any[] = []

  /**
   * @ignore
   * 上传成功的文件信息的uuid
   */
  uploadedFileUuids: any[] = []

  /**
   * @ignore
   * 是否选中,在clickThisFile事件中使用,如果直接点击已经上传的某一项,就直接将这一项的数据放在checkedFile中
   */
  isChecked: boolean = false

  /**
   * @ignore
   * 存放被选中的文件的信息
   */
  checkedFile: any

  /**
   * @ignore
   * 存放根据策略得到的提示语
   */
  tip: any

  /**
   * @ignore
   * 根据策略查询配置是否成功,如果没有成功,就展示假上传按钮,默认成功
   */
  getOptionSuccess: boolean = true

  /**
   * @ignore
   * 裁剪功能:是否需要裁剪后再上传
   */
  isCropper: boolean = false

  /**
   * @ignore
   * 裁剪功能:裁剪的图片img元素
   */
  image: any

  /**
   * @ignore
   * 裁剪功能:新建的裁剪对象
   */
  cropper: any

  /**
   * @ignore
   * 裁剪功能:待上传,要进行裁剪的文件
   */
  waitToUploadImg: any

  /**
   * @ignore
   * 裁剪功能:裁剪区域是否显示,默认不显示,当点击裁剪图标时,显示,裁剪完成后隐藏
   */
  showCutArea: boolean = false

  /**
   * @ignore
   * 文件处理微服务api
   */
  fileUrl: string = environment.fileWebAPI

  /**
   * @ignore
   * 修改了文件名或描述的文件列表
   */
  editedList: any[] = []

  /**
   * @ignore
   * 选择的文件到上传队列之后有没有出现错误,默认没有，如果有，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
   */
  hasError: boolean = false

  /**
   * @ignore
   * 策略中允许上传类型是否包含图片类型，默认是，如果包含才会出现 临时的 缩略图和水印配置
   */
  allowImage: boolean = false

  /**
   * @ignore
   * 是否生成缩略图
   */
  isThumb: boolean = false

  /**
   * @ignore
   * 是否生成水印
   */
  isWater: boolean = false

  /**
   * @ignore
   * 创建上传对象需要的参数
   */
  options5: any = {
    server: environment.fileWebAPI + "file/fileUpload", //文件接收服务器
    auto: false,   //选完文件后是否自动上传
    resize: false,  //
    dnd: '#uploader',   //指定 Drag And Drop 拖拽的容器,如果不知道,择不启动
    paste: '#uploader',  //指定监听paste事件的容器,如果不指定则不起都过此功能.此功能为通过粘贴来添加截屏的图片,建议设置为document.body
    pick: {
      id: '#filePicker',
      label: '选择文件',
      multiple: true,   //是否能够多个文件上传,数据从父组件传递过来
    },
    accept: {   //只允许上传图片文件
      title: '',
      extensions: 'gif,jpg,jpeg,bmp,png',
      // mimeTypes: 'image/*',
      //点击选择文件之后会有延迟,解决方法:
      mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png,image/bmp'
    },
    fileNumLimit: 10,   //验证文件总数量, 超出则不允许加入队列。
    compress: false,
    chunked: true,     //分片上传大文件
    chunkSize: 1024 * 512,
    chunkRetry: 3,     // 如果某个分片由于网络出现问题错误,允许自动上传多少次
    threads: 5,        //最大上传并发数
    method: 'Post',
    fileSizeLimit: undefined,  //验证文件总大小是否超出限制,超出则不允许加入队列
    fileSingleSizeLimit: undefined,  //验证单个文件大小是否超出限制,超出则不允许加入队列
    duplicate: true,   //允许重复上传文件

  }

  /**
   * @ignore
   * 选择文件按钮是否已经初始化好了，是否可以点击，默认不能点击
   */
  createComplete: boolean = false

  constructor(

    private el: ElementRef,
    private http: SwHttpClientService,
    private Jwt: SwJwtService,
    private renderer2: Renderer2,
    private box: SwMassageBoxService,
    private systemId: SystemIdService,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private view: SwViewFileService,  //文件预览服务
    private create: SwCreateModalComponentService,
    private getSuffixImgService: GetSuffixImgService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.label3 = this.label3 || 'filePicker';
    this.options5.pick.id = this.label3 ? '#' + this.label3 : '#filePicker';
  }

  ngAfterViewInit(): void {
    if (this.param && this.param.fileCode) {
      this.list = {
        'addList': [],
        'delList': []
      }
      this.fileCode = this.param.fileCode || this.fileCode
      this.label3 = this.param.label3 || this.label3
      this.fileBusinessId = this.param.fileBusinessId || this.fileBusinessId
      this.fileInfoIds = this.param.fileInfoIds || this.fileInfoIds
      //如果是业务方面动态创建上传组件模态框，就根据传入的参数来查询策略和文件列表
      if (this.param.fileBusinessId && this.param.fileCode) {
        this.getShowList1(this.param.fileBusinessId, this.param.fileCode)
      }
      //业务为空,就通过文件id获取
      if (!this.param.fileBusinessId && this.param.fileInfoIds.length != 0) {
        this.getShowList2(this.param.fileInfoIds)
      }

      //根据code 查询上传前配置
      if (this.param.fileCode) {
        this.http.Get(this.fileUrl + 'fileConfig/queryFileConfigOfUploadBeforeByCode?code=' + this.param.fileCode)
          .subscribe(ret => {
            if (ret && ret.code == 200) {
              this.uploadObj = ret.data;
              if (this.uploadObj && this.uploadObj.config.status != true) {
                this.box.danger("此策略已禁用")
              } else {
                //策略正常使用
                this.tip = '(允许上传类型:' + (this.uploadObj.suffix || '请在上传策略中配置允许上传类型') + '; ' + '允许上传文件大小:' + (this.uploadObj.config.allowSize ? this.uploadObj.config.allowSize + 'M; ' : '无限制; ') + (this.uploadObj.config.tip ? this.uploadObj.config.tip : '') + ')'
                //看策略中是否允许图片上传
                this.allowImage = this.uploadObj.suffix.indexOf('jpg') > -1 || this.uploadObj.suffix.indexOf('jpeg') > -1 || this.uploadObj.suffix.indexOf('bmp') > -1 || this.uploadObj.suffix.indexOf('png') > -1 || this.uploadObj.suffix.indexOf('gif') > -1
                this.cd.detectChanges();  //避免变更检测报错
                if (this.allowImage) {
                  this.isThumb = this.uploadObj.isThumb  //回显策略配置的值--生成缩略图
                  this.isWater = this.uploadObj.isWater  //回显策略配置的值--生成水印
                }
                this.options5.fileSingleSizeLimit = this.uploadObj.config.allowSize ? this.uploadObj.config.allowSize * 1024 * 1024 : undefined;
                this.options5.pick.multiple = this.uploadObj.multiple
                this.isCropper = this.uploadObj.isCut  //是否裁剪
                this.options5.accept.extensions = this.uploadObj.suffix
                let arr = this.uploadObj.suffix.split(',')
                arr = arr.map((item: any) => '.' + item)
                this.options5.accept.mimeTypes = arr.join(',')
                // this.uploadPath = this.uploadObj.config.filePath

                this.fileUploader = WebUploader1.create(this.options5)
                this.createComplete = true  //可以开始选择文件了
                this.cd.detectChanges();  //避免变更检测报错
                this.clickToSelect()
              }
            } else {
              //查询失败
              this.box.danger("策略查询失败")
              this.getOptionSuccess = false  //展示假按钮
            }
          })
      }

    } else if (!this.param && this.uploadObj && this.uploadObj.config.status == true) {  //策略是启用状态
      //看策略中是否允许图片上传
      this.allowImage = this.uploadObj.suffix.indexOf('jpg') > -1 || this.uploadObj.suffix.indexOf('jpeg') > -1 || this.uploadObj.suffix.indexOf('bmp') > -1 || this.uploadObj.suffix.indexOf('png') > -1 || this.uploadObj.suffix.indexOf('gif') > -1
      this.cd.detectChanges();  //避免变更检测报错
      if (this.allowImage) {
        this.isThumb = this.uploadObj.isThumb  //回显策略配置的值--生成缩略图
        this.isWater = this.uploadObj.isWater  //回显策略配置的值--生成水印
      }
      this.options5.fileSingleSizeLimit = this.uploadObj.config.allowSize ? this.uploadObj.config.allowSize * 1024 * 1024 : undefined;
      this.options5.pick.multiple = this.uploadObj.multiple
      this.isCropper = this.uploadObj.isCut  //是否裁剪
      this.options5.accept.extensions = this.uploadObj.suffix

      // bug: 允许文件类型中有 pdf文件,它的mimetype是application/x-pdf,但是在选择文件的时候,自定义文件中没有出现pdf文件
      // 注意: options5.accept.mimeTypes 属性是指定 input[type="file"] 的 accpet 属性的值
      /* // 解决方法1: 将 accept="image/jpg,application/x-pdf" 改为 accept="image/jpg,application/pdf"  ,这要直接在系统配置中修改
      this.options5.accept.mimeTypes = this.uploadObj.type   //accept="image/jpg,application/x-pdf " 
      */
      // 解决方法2: 将 accept="doc,docx,jpg,jpeg,png,bmp,zip,pdf" 需要改成 accept=".doc,.docx,.jpg,.jpeg,.png,.bmp,.zip,.pdf" (现在用的方法,如下3行代码)
      let arr = this.uploadObj.suffix.split(',')
      arr = arr.map((item: any) => '.' + item)
      this.options5.accept.mimeTypes = arr.join(',')
      // this.uploadPath = this.uploadObj.config.filePath

      this.fileUploader = WebUploader1.create(this.options5)
      this.createComplete = true  //可以开始选择文件了
      this.cd.detectChanges();  //避免变更检测报错
      this.clickToSelect()
      // this.getOptionSuccess = true  //正常展示
    } else if (!this.param && this.uploadObj && this.uploadObj.config.status != true) {
      this.box.danger("此策略已禁用")
      this.allowImage = false
      this.cd.detectChanges();  //避免变更检测报错
      // this.getOptionSuccess = false  //展示假按钮
    }
    //如果没有传递策略,就创建默认的上传对象,只能上传图片
    if (!this.fileFunctionId && !this.fileCode && !this.param.fileCode) {
      this.fileUploader = WebUploader1.create(this.options5)
      this.createComplete = true  //可以开始选择文件了
      this.cd.detectChanges();  //避免变更检测报错
      // this.getOptionSuccess = true  //正常展示
    }
  }

  /**
  * 其他业务地方动态创建上传组件模态框时，根据业务id和策略标识进行回显(从附件表中查)
  * @ignore
  * @param fileBusinessId 
  * @param fileCode 
  */
  getShowList1(fileBusinessId: any, fileCode: any) {
    this.http.Post(environment.fileWebAPI + 'refFileObject/queryPageList', { 'objectId': fileBusinessId, 'code': fileCode, 'pageSize': 0, 'pageNum': 0 })
      .subscribe(res => {
        if (res && res.code == 200) {
          let resArr = res.data.records.filter((item: any) => !item.isDeleted)  //过滤掉伪删除的文件
          resArr.forEach((item: any) => {
            this.getImgBySuffix(item)
            item.nameWithoutSuffix = item.fileOldname.slice(0, item.fileOldname.lastIndexOf('.'))
          });
          this.showList2 = JSON.parse(JSON.stringify(resArr))
        } else {
          this.box.danger("网络错误,无法获取列表")
        }
      })
  }

  /**
  * 其他业务地方动态创建上传组件模态框时，根据文件信息的fileIndoId进行回显(从文件系统中查),文件的sort默认都0,且不能修改,业务只有排序是修改的附件表中的文件属性
  * @ignore
  * @param ids
  */
  getShowList2(ids: any) {
    let datas = {
      ids: ids
    }
    this.http.Post(this.fileUrl + "fileInfo/queryByIdList", datas).subscribe(res => {
      if (res && res.code == 200) {
        let resArr = res.data.filter((item: any) => !item.isDeleted)  //过滤掉伪删除的文件
        resArr.forEach((item: any) => {
          this.getImgBySuffix(item)
          item.sort = 0
          item.nameWithoutSuffix = item.fileOldname.slice(0, item.fileOldname.lastIndexOf('.'))
        });
        this.showList2 = JSON.parse(JSON.stringify(resArr))
      } else {
        this.box.danger("网络错误,无法获取列表")
      }
    })
  }

  /**
  * 点击选择图片按钮,将之前的队列清空,重新选择要上传的文件
  * @ignore
  */
  clickToSelect() {
    this.fileUploader.refresh()
    //将上次的已将上传的文件信息清空
    //  this.fileList = []
    //当文件加到队列之前
    this.fileUploader.on('beforeFileQueued', (file: any) => {
      //每次有文件加入队列，先把 hasError初始化一下
      this.hasError = false
      if (this.options5.accept.extensions && this.options5.accept.extensions.indexOf(file.ext.toLocaleLowerCase()) == -1) {
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        //没有这个后缀
        this.box.danger('文件格式不正确')
        return
      }
      if (file.size > this.options5.fileSingleSizeLimit) {
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        this.box.danger(file.name + '大小超过限制')
        return
      }
      if (file.size == 0) {
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        this.box.danger(file.name + ' 的文件大小为0KB，请选择其他文件上传')
        return
      }
      if (this.isCropper && file.source.source.cutted) {
        //如果加入队列的是裁剪后的图片,将裁剪前的图片从队列中删除
        this.fileUploader.removeFile(this.waitToUploadImg, true)
        //将裁剪前的文件从 this.fileList中删除,即从页面上删除
        let itemIndex = this.fileList.indexOf(this.waitToUploadImg)
        this.fileList.splice(itemIndex, 1)
      }
    })
    //当一批文件添加到队列以后触发
    this.fileUploader.on('filesQueued', (files: any) => {
      if (!this.options5.pick.multiple) {
        //单张上传, 上传队列中也只有一个文件
        this.fileList.forEach(item => {
          this.fileUploader.removeFile(item.id)
        })
        this.fileList = []
        this.fileList.push(files[0])
      } else {
        this.fileList = this.fileList.concat(files)
        //允许多个文件上传的时候，进行提示，一次性最多只能上传N个文件
        if (this.fileList.length >= this.options5.fileNumLimit) {
          this.box.danger('最多一次性上传10项资产')
        }
      }
      this.fileList.forEach(item => {
        // item.fileSizeToKB = Math.ceil(item.size /1024 *100) /100
        //将每个文件的进度初始化为0 , 进度条显示 isShowBar初始化为false
        item.percentage = 0
        item.isShowBar = false
        //队列中的文件状态
        item.status = 'waitToUpload'
        //制作每个文件的缩略图
        this.fileUploader.makeThumb(item, (error: any, src: any) => {
          if (error) {
            //根据后缀得到文件类型图片
            item.src = this.getSuffixImgService.getFileTypeImg(item.ext)
            return
          }
          item.src = src
        }, 50, 50)
      });
      //当有文件被添加到队列的时候,如果需要再次选择文件,这里需要重新实例化
      // this.fileUploader.refresh() 
    })

    //文件上传之前触发,设置参数
    this.fileUploader.on('uploadBeforeSend', (obj: any, data: any, headers: any) => {
      this.uploadObj.isWater = this.allowImage ? this.isWater : false
      this.uploadObj.isThumb = this.allowImage ? this.isThumb : false
      //增加请求头
      headers['AuthorizationU'] = this.Jwt.getToken('token'),
        data.id = obj.file.id,              //wu_id,webUpload组件自己排的ID，通过此参数获取相应MD5值
        data.size = obj.file.size,          //文件总文件字节大小
        data.byteNow = obj.blob.size,       //定义的每个分片的字节大小
        data.chunks = obj.chunks,           //总分片数
        data.chunk = obj.chunk,             //当前分片数，当前是第几分片
        data.name = this.getFileName(obj.file.name),          //文件名
        data.file = JSON.stringify(obj.blob),  //分片对象
        // data.md5 = Md5.hashStr(obj.file.id + ':'+obj.file.name + obj.file.lastModifiedDate+'#'),        //将md5值进行Md5加密 , 文件的MD5值String , 后台根据这个md5值进行分片的合并,所以,每一个文件的所有分片的md5要一致
        data.systemId = this.systemId.getSystemId(),                   //系统编号 随便写
        // data.functionId = this.fileFunctionId ? this.fileFunctionId : '1',                //策略id
        data.code = this.fileCode ? this.fileCode : 'DEFAULT',                //策略id
        data.uploadPath = this.uploadPath,             //文件保存路径，没有的话就保存在DEFAULT里面  
        data.uploadDirectory = environment.uploadDirectory,          //项目路径
        data.configVO = JSON.stringify(this.uploadObj)  //根据策略查到的上传前配置项
    })

    //上传过程,每个分片对象及图片的上传进度
    this.fileUploader.on("uploadProgress", (file: File, percentage: Number) => {
      this.fileList.forEach(item => {
        //展示进度
        if (item.name == file.name && item.id == file['id']) {
          //找到对应的文件
          if (percentage > 0) {
            //上传开始,显示进度条
            item.isShowBar = true
            item.percentage = percentage
            item.percentage = Math.floor(item.percentage * 100)
          }
        }
      })
    })

    //上传成功触发
    this.fileUploader.on('uploadSuccess', (file: any, response: any) => {
      if (response.code == 200) {
        const uploadedFileId = response.data && response.data.uuid;
        if (typeof uploadedFileId !== 'string' || !uploadedFileId.trim()) {
          file.isShowBar = false;
          file.status = 'fail';
          this.box.danger('未获取到上传文件标识，请重新上传');
          return;
        }
        //已上传成功就取查找文件,实时更新在showList2中,而不是全部上传完之后一起查询所有文件
        let datas = {
          'fileInfoId': uploadedFileId
        }
        //从文件系统中一一查找文件信息
        this.http.Post(this.fileUrl + "fileInfo/queryPageList", datas).subscribe(result => {
          if (result.code == 200) {
            const fileItem = result.data && Array.isArray(result.data.records)
              ? result.data.records.find(item => item.fileInfoId === uploadedFileId) : null;
            if (!fileItem) {
              file.isShowBar = false;
              file.status = 'fail';
              this.box.danger('上传文件信息不匹配，请重新上传');
              return;
            }
            this.fileList.forEach(item => {
              if (item.name == file.name && item.id == file['id']) {
                //如果上传成功,进度条消失
                item.isShowBar = false
                //显示成功状态,待上传文件在列表中消失
                item.status = 'success'
              }
            })
            this.fileList = this.fileList.filter(v => v != file)
            //上传成功后将所有上传的文件信息存放在 theUploadedFiles 数组中
            this.uploadedFileUuids.push(response.data.uuid)

            //默认文件排序为0
            fileItem.sort = 0
            //根据文件后缀判断显示的图片,如果不是图片类型就使用默认图片
            this.getImgBySuffix(fileItem)
            //页面上显示的文件名是不需要后缀的
            fileItem.nameWithoutSuffix = fileItem.fileOldname.slice(0, fileItem.fileOldname.lastIndexOf('.'))

            if (this.onlyOneFile) {
              //单张上传
              this.list.addList = [fileItem]
              this.showList2 = [fileItem]
            } else {
              this.list.addList.push(fileItem)
              this.showList2.unshift(fileItem)
            }
          }
        })
        if (this.fileUploader.getFiles('progress').length == 0) {
          //如果没有在上传中状态的文件,说明全部上传完毕,获取所有上传完文件信息
          //上传完成后重新获取所有已经上传的所有的文件信息,将数组更新,重新渲染页面
          // this.getUploadedFiles(this.uploadedFileUuids)
          this.uploadedFileUuids = []    // 每次重新选择文件上传的时候都将 uuid数组重置为空
        }
      } else {
        //相当于上传失败
        file.isShowBar = false
        file.status = 'fail'
        file.completeMsg = response.msg
        file.completeCode = response.code
      }
    })

    //上传失败触发
    this.fileUploader.on('uploadError', (file: any, reason: any) => {
      //上传失败进度条也要消失,并显示上传失败
      this.fileList.forEach(item => {
        if (item.name == file.name) {
          item.isShowBar = false
          //显示失败状态
          item.status = 'fail'
        }
      })
      //清空待上传文件队列
      this.fileList.forEach(file => {
        this.fileUploader.removeFile(file.id)
      });
    })

    //当开始上传流程暂停时触发
    this.fileUploader.on('stopUpload', () => {
      //console.log('当开始上传流程暂停时触发');

    })

    //校验不通过时发生
    this.fileUploader.on('error', (type: any) => {
      //如果这里的校验没通过，而加入到队列时没发现这个问题，就提示
      if (type == 'Q_TYPE_DENIED' && !this.hasError) {
        this.box.danger('文件校验不通过')
      }
    })

    //解决第一次选择文件没有上传,重新选择文件出现队列错误的问题
    this.fileUploader.reset()
  }

  /**
    * 获取已将上传的文件在列表中进行展示
    * @ignore
    * @param uuids
    */
  getUploadedFiles(uuids: any) {
    if (uuids) {
      let i = 0
      uuids.forEach((uuid: any) => {
        let datas = {
          'fileInfoId': uuid
        }
        //从文件系统中一一查找文件信息
        this.http.Post(this.fileUrl + "fileInfo/queryPageList", datas)
          .subscribe(
            result => {
              if (result.code == 200) {
                //让 i 来计数,看看最终查到的文件个数是否与上传成功的个数一致
                i++
                let fileItem = result.data.records[0]
                //默认文件排序为0
                fileItem.sort = 0
                //根据文件后缀判断显示的图片,如果不是图片类型就使用默认图片
                this.getImgBySuffix(fileItem)
                //页面上显示的文件名是不需要后缀的
                fileItem.nameWithoutSuffix = fileItem.fileOldname.slice(0, fileItem.fileOldname.lastIndexOf('.'))
                this.list.addList.push(fileItem)
                this.showList2.unshift(fileItem)
              }
            })
      });
    }
  }

  /**
  * 根据文件后缀判断显示的图片,如果不是图片类型就使用默认图片
  * @ignore
  * @param file
  */
  getImgBySuffix(file: any) {
    if (file.fileSuffix) {
      let fileSuffix = file.fileSuffix.toLocaleLowerCase()
      if (fileSuffix) {
        //根据后缀得到文件类型图片
        file.src = this.getSuffixImgService.getFileTypeImg(fileSuffix)
        if (file.src == 'assets/Images/files/img.png') {
          let name: string = file.fileName;
          if (name) {
            let index = name.lastIndexOf('.');
            name = name.substring(0, index) + '_300@x.' + file.fileSuffix
            file.src = environment.staticFileUrl + file.filePath + 'THUMB/' + name
          }
        }
      }
    }
  }

  /**
   * 解决点击上传按钮,没有反应,无法上传的问题,直接写一个点击事件,调用 upload方法手动上传
   * @ignore
   */
  clickToUpload() {
    this.fileUploader.upload()
    //开始上传之后,缩略图消失,展示上传
    this.fileUploader.refresh()
  }

  /**
  * 点击待上传文件的删除按钮,将文件从对列中删除
  * @ignore
  * @param fileId
  */
  deleteFileFromQueued(file: any) {
    if (file.percentage == 0) {
      //文件还没开始上传
      //使用数组的filter过滤方法,将不符合的元素去掉,满足条件的留下来,返回一个新数组,不改变原数组
      this.fileList = this.fileList.filter(f => f.id !== file.id)
      //将删除的文件从队列中删除
      this.fileUploader.removeFile(file.id)
    } else {
      //文件已经在上传中，但上传没有结束
      this.fileList = this.fileList.filter(f => f.id !== file.id)
      //将删除的文件从队列中删除
      this.fileUploader.removeFile(file.id)
      // 标记文件状态为已取消, 同时将中断文件传输
      this.fileUploader.cancelFile(file.id)
    }
  }



  //暂停上传
  stopUpload(file: any) {
    file.stop = true
    this.fileUploader.stop(file)
  }
  // 重新开始上传
  reStartUpload(file: any) {
    file.stop = false
    this.fileUploader.upload(file)
  }

  /**
    * 点击模态框的文件的删除按钮,如果该文件是回显的文件就加到delList中去,如果是刚刚新上传的文件就将之从addList中删除 ,并将之从showList2中删除
    * @ignore
    * @param item
    */
  deteleFile(item: any) {
    //创建dom节点
    const com = document.createElement(SwMassageConfirmComponent.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwMassageConfirmComponent);
    const swMassageConfirmComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(swMassageConfirmComponentRef.hostView);

    //组件的关闭事件getFormLink
    swMassageConfirmComponentRef.instance["voted"].subscribe((data: any) => {
      if (data) {
        //从文件系统中删除文件
        let data = {
          'ids': [String([item.fileInfoId])]
        }
        this.http.Post(this.fileUrl + 'fileInfo/deleteBatch', data)
          .subscribe(res => {
            //删除后重新获取所有已经上传的所有的文件信息,将数组更新,重新渲染页面 
            if (res.code == 200) {
              //删除的是刚刚上传的文件,那么该文件要从addList中删除
              this.list.addList = this.list.addList.filter((ele: any) => ele.fileInfoId !== item.fileInfoId)
              //如果 fileBusinessId 业务id存在且 删除的文件的 fileObjectId 存在,说明该文件是从附件表里面查出来的,需要加到delList里面去
              if (this.fileBusinessId && item.fileObjectId) {
                //如果是附件表中已存在的,就加到delList里面
                this.list.delList.push(item.fileInfoId)
              }
              //如果 fileBusinessId 业务id不存在, fileInfoIds 存在,且删除的文件id在 fileInfoIds 中存在,也要加到 delList里面去
              if (!this.fileBusinessId && this.fileInfoIds.length && this.fileInfoIds.indexOf(item.fileInfoId) != -1) {
                this.list.delList.push(item.fileInfoId)
              }
              //将文件信息从模态框中删除,点击保存的时候才能从页面中删除
              this.showList2 = this.showList2.filter(ele => ele.fileInfoId !== item.fileInfoId)
            } else {
              this.box.danger("删除失败")
            }
          })
      }
      document.body.removeChild(com);
      this.applicationRef.detachView(swMassageConfirmComponentRef.hostView);
      swMassageConfirmComponentRef.destroy()

    });

    swMassageConfirmComponentRef.instance["Title"] = "该文件将从文件系统中删除，确认删除吗？";
    swMassageConfirmComponentRef.instance["createType"] = 2;
    document.body.appendChild(com);
  }

  /**
  * 点击已经上传的文件的下载按钮,将文件下载到本地
  * @ignore
  * @param fileId
  */
  downloadFile(fileId: any) {
    window.location.href = this.fileUrl + "fileDownload/download?fileId=" + fileId;
  }

  /**
    * 输入的排序只能是正整数,使用正则,将非数字用空字符串替换
    * @ignore
    * @param event
    * @param item
    * @param i
    */
  enterNum(event: any, item: any, i: any) {
    this.showList2[i].sort = event.target.value.replace(/[^\d]/g, '')
    if (this.showList2[i].sort && this.showList2[i].sort[0] == 0 && this.showList2[i].sort.length != 1) {
      this.showList2[i].sort = this.showList2[i].sort.slice(1, this.showList2[i].sort.length)
    }
    event.target.value = this.showList2[i].sort
    //修改排序之后,先将模态框上的文件列表重新排序,之后点击确认的时候,将页面上的文件列表更新
    this.sortUpdate(this.showList2)
  }

  /**
    * 根据sort将showList2进行排序
    * @ignore
    * @param arr
    */
  sortUpdate(arr: any) {
    return arr.sort(function (a: any, b: any) {
      return a.sort - b.sort
    })
  }

  /**
    * 修改文件名,
    * @ignore
    * @param event
    * @param item
    */
  fileNameOnBlur(event: any, item: any) {
    if (!item.nameWithoutSuffix) {
      //如果修改后的文件名为空,就不进行
      item.nameWithoutSuffix = item.fileOldname.slice(0, item.fileOldname.lastIndexOf('.'))
      return
    }
    //如果 editedList中没有这个文件信息,就新增
    // let newName = item.nameWithoutSuffix + item.fileOldname.slice(item.fileOldname.lastIndexOf('.'),item.fileOldname.length)
    let newName = item.nameWithoutSuffix + '.' + item.fileSuffix
    //arr 是 fileInfoId 组成的数组
    let arr = this.editedList.map(item => item.fileInfoId)
    if (arr.indexOf(item.fileInfoId) != -1) {  //已经存在
      this.editedList[arr.indexOf(item.fileInfoId)].fileOldname = newName
    } else {    //如果不存在
      this.editedList.push({ 'fileInfoId': item.fileInfoId, 'fileOldname': newName, 'description': item.description })
    }
  }

  /**
  * 修改文件描述信息
  * @ignore
  * @param event
  * @param item
  */
  fileDesOnBlur(event: any, item: any) {
    //如果 editedList中没有这个文件信息,就新增
    //arr 是 fileInfoId 组成的数组
    let arr = this.editedList.map(item => item.fileInfoId)
    if (arr.indexOf(item.fileInfoId) != -1) {  //已经存在
      this.editedList[arr.indexOf(item.fileInfoId)].description = event.target.value
    } else {    //如果不存在
      this.editedList.push({ 'fileInfoId': item.fileInfoId, 'fileOldname': item.fileOldname, 'description': event.target.value })
    }
  }

  /**
  * 模态框确认按钮,提示用户将待上传文件上传或删除,否则不能点击确认
  * @ignore
  */
  sure() {
    //有时候上传完成了,但是相当于上传失败,文件还在队列中
    if (this.fileList.length != 0) {
      //清空待上传文件队列
      let flag = 0
      this.fileList.forEach(file => {
        if (file.completeCode && file.completeCode != 200) {
          flag++
          this.fileUploader.removeFile(file.id)
        }
      });
      if (flag != this.fileList.length) {
        this.box.danger("请将待上传文件上传或删除")
      } else {
        this.fileList = []  //将页面上的队列清空
        //点击确认的时候: 
        this.sureToDo()
      }
    } else {
      //点击确认的时候: 
      this.sureToDo()
    }
  }

  /**
  * 点击确认关闭模态框时要做的事
  * @ignore
  */
  sureToDo() {
    // 1.如果文件名或描述信息改变了,发请求修改文件系统中的信息; 
    if (this.editedList.length) {
      //改变文件系统中的信息
      this.editedList.forEach(item => {
        //修改文件信息
        let params = {
          'entity': item,
          'param': {}
        }
        this.http.Post(this.fileUrl + "fileInfo/updateById", params).subscribe(res => {
          if (res && res.code == 200) {
            //修改成功之后将模态框信息刷新
            for (let i = 0; i < this.showList2.length; i++) {
              if (item.fileInfoId == this.showList2[i].fileInfoId) {
                this.showList2[i].fileOldname = item.fileOldname
                this.showList2[i].description = item.description
                break
              }
            }
          } else {
            this.box.danger("fileInfoId为 item.fileInfoId 的文件的文件名或描述信息修改失败")
            //文件信息修改失败的话,showList2的nameWithoutSuffix也要变回原样
            for (let i = 0; i < this.showList2.length; i++) {
              if (item.fileInfoId == this.showList2[i].fileInfoId) {
                this.showList2[i].nameWithoutSuffix = this.showList2[i].fileOldname.slice(0, this.showList2[i].fileOldname.lastIndexOf('.'))
                break
              }
            }
          }
        })
      })
    }
    // 2. 将模态框的文件信息同步更新到页面上; 
    // 3. 将变更的文件信息传递给父组件; 
    // 4. 将页面的文件信息传递给父组件; 
    let passInfo = {
      list: this.list,
      showList2: this.showList2
    }
    // 5.先关闭模态框，再销毁组件
    this.fileUploadModal.toggle()
    this.callback.emit(passInfo)
  }



  /**
  * 模态框关闭按钮,清空待上传队列
  * @ignore
  */
  close() {
    if (this.fileList.length != 0) {
      this.fileList.forEach(item => {
        //将待上传的文件从队列中删除
        this.fileUploader.removeFile(item.id)
      })
    }
    this.fileList = []
    //关闭模态框
    this.fileUploadModal.toggle()
    //销毁组件
    this.callback.emit(false)
  }

  /**
  * 预览功能
  * @ignore
  */
  viewFile(file: any) {
    //调用文件预览服务
    this.view.viewFile(environment.staticFileUrl + file.filePath + file.fileName, file.serverPath + file.filePath + file.fileName, this.watermark)
  }

  /**
  * 点击已上传文件列表中的某一项,将这一个文件的相关信息返回
  * @ignore
  * @param fileId
  */
  clickThisFile(fileId: any) {
    this.checkedFile = this.showList2.filter(item => item.fileInfoId == fileId)
  }

  /**
  * 点击进行裁剪
  * @ignore
  */
  clickToCut(item: any) {
    if (this.isCropper) {  //裁剪后上传
      this.showCutArea = true  //显示裁剪区域
      this.waitToUploadImg = item
      //裁剪功能
      let fr = new FileReader();
      fr.readAsDataURL(item.source.source);
      fr.onload = () => {   //异步读取文件结束之后
        this.image = this.el.nativeElement.querySelector('#cropperImg')  //裁剪功能需要的
        this.image['setAttribute']('src', fr.result);
        this.iniCropper();
      };
    }
  }

  /**
  * 裁剪初始化
  * @ignore
  */
  iniCropper() {
    this.cropper = new Cropper(this.image, {
      //  aspectRatio: 16 / 16,    //裁剪区域的比例,不设置的话,默认 NaN , 最大宽高就是父容器的宽高
      crop(event) {
      },
      viewMode: 1
    });
  }

  /**
  * 确认裁剪并将裁剪后的图片加入队列
  * @ignore
  */
  cutImage() {
    const canVas = this.image.cropper['getCroppedCanvas']('', { 'width': 500, 'height': 200 });
    var dataURL = canVas.toDataURL();
    var blob: any = this.processData(dataURL, this.waitToUploadImg.type);
    blob['cutted'] = true
    blob["name"] = this.waitToUploadImg.name   //裁剪后的图片名与裁剪前一致
    this.fileUploader.addFiles(blob)   //将文件加入到队列中,哪怕加入的是blob格式,之后也会自动转化为 WUFile

    //将文件加入到队列中,因为只允许单个文件上传,所以将裁剪后的图片加入队列后,原来的图片就不在队列中了
    // canVas.toBlob( blob =>{  //报错： canVas.toBlob is not a function(…)
    //   //将裁剪前的文件从队列中删除
    //   blob.cutted = true
    //   blob.name = this.waitToUploadImg.name   //裁剪后的图片名与裁剪前一致
    //   this.fileUploader.addFiles(blob)   //将裁好的文件加入到队列中,哪怕加入的是blob格式,之后也会自动转化为 WUFile
    // }, this.waitToUploadImg.type , 0.95)
    this.image.cropper['destroy']()  //销毁cropper并从图像中删除整个cropper
    this.showCutArea = false
  }

  /* 使用二进制方式处理dataUrl */
  processData(dataUrl: any, type: any) {
    var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { 'type': type });
  }

  imgSuffix: any[] = ['jpg', 'jpeg', 'png', 'bmp', 'gif']  //图片的文件类型，只有待上传文件是图片且策略中有配置的时候才有裁剪按钮
  /**
  * 文件加入到上传队列中之后，判断是否出现裁剪按钮
  * @ignore
  */
  showCropperBtn(file: any) {
    return this.imgSuffix.indexOf(file.ext.toLocaleLowerCase()) != -1 && this.isCropper
  }

  /**
   * 获取文件名
   * @param name 
   * @returns 
   */
  getFileName(name: any) {
    if (this.newFileName == "") {
      return name;
    } else {
      let arr = name.split('.');
      let newName = this.newFileName + "." + arr[arr.length - 1];
      return newName;
    }
  }
}
